var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import siteApi from "../../site.api.config";
import { store } from "../redux/store";
import { CalcRequestPlace } from "../types/enums";
export var getVerification = function (props) { return __awaiter(void 0, void 0, void 0, function () {
    var data, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, siteApi.post("loan/GetVerification", {
                        "sum": props.sum,
                        "term": props.term,
                        "keyDzt": props.keyDzt,
                        "loanType": props.loanType,
                        "phone": props.phone
                    })];
            case 1:
                data = (_a.sent()).data;
                if (!data) {
                    throw new Error("Тариф не выбран");
                }
                if (props.customLink) {
                    window.location.href = props.customLink;
                }
                else {
                    window.location.href = data.data;
                }
                return [2 /*return*/, data];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, error_1];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var sendUpdateForm = function (context_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([context_1], args_1, true), void 0, function (context, loanType) {
        var _a, sumTerm, selectedTariff, lifeInsurance, creditRating, selectedDaysIndex, requestPlace, unsecuredLoanType, autoLoanType, loanTypeCheck, selectedDaysString, index, pairs, pair, request, res;
        var _b, _c, _d, _e, _f, _g, _h, _j;
        if (loanType === void 0) { loanType = 0; }
        return __generator(this, function (_k) {
            try {
                _a = store.getState(), sumTerm = _a.sumTerm, selectedTariff = _a.selectedTariff, lifeInsurance = _a.lifeInsurance, creditRating = _a.creditRating, selectedDaysIndex = _a.selectedDays, requestPlace = _a.requestPlace;
                unsecuredLoanType = requestPlace.requestPlace === CalcRequestPlace.STEP32 || requestPlace.requestPlace === CalcRequestPlace.PUBLIC;
                autoLoanType = requestPlace.requestPlace === CalcRequestPlace.STEP232;
                loanTypeCheck = unsecuredLoanType ? 0 : (autoLoanType ? 1 : loanType);
                selectedDaysString = null;
                index = selectedDaysIndex === null || selectedDaysIndex === void 0 ? void 0 : selectedDaysIndex.selectedDaysFromStep32;
                if (typeof index === 'number' && index >= 0) {
                    pairs = (_e = (_d = (_c = (_b = selectedTariff.tariff) === null || _b === void 0 ? void 0 : _b.listPaymentDatePairs) === null || _c === void 0 ? void 0 : _c.slice()) === null || _d === void 0 ? void 0 : _d.sort(function (a, b) { return a.orderBy - b.orderBy; })) === null || _e === void 0 ? void 0 : _e.reverse();
                    pair = pairs === null || pairs === void 0 ? void 0 : pairs[index];
                    if (pair) {
                        selectedDaysString = "".concat(String(pair.firstDay).padStart(2, '0'), ",").concat(String(pair.secondDay).padStart(2, '0'));
                    }
                }
                request = {
                    data: __assign({ "Summa": (_f = sumTerm.sumTerm) === null || _f === void 0 ? void 0 : _f.sum, "Srok": (_g = sumTerm.sumTerm) === null || _g === void 0 ? void 0 : _g.term.value, "keyDZT": (_h = selectedTariff.tariff) === null || _h === void 0 ? void 0 : _h.keyDzt, "keyTL": (_j = selectedTariff.tariff) === null || _j === void 0 ? void 0 : _j.keyTl, "loanType": loanTypeCheck, "acceptInsurance": lifeInsurance.InsuranceAgree, "acceptPersonalScore": creditRating.CreditRatingAgree }, (selectedDaysString ? { "selectedDaysFromStep32": selectedDaysString } : {})),
                    action: "update",
                    context: context
                };
                res = window.BX.onCustomEvent('requestActionLoadData', request);
                return [2 /*return*/];
            }
            catch (error) {
                return [2 /*return*/, error];
            }
            return [2 /*return*/];
        });
    });
};
